import type { Config } from '@measured/puck';
import { HeroPrimary, HeroPrimaryConfig } from './HeroPrimary';
import { HeroPremium, HeroPremiumConfig } from './HeroPremium';
import { HeroMinimal, HeroMinimalConfig } from './HeroMinimal';
import { HeroDiagnostic, HeroDiagnosticConfig } from './HeroDiagnostic';
import { HeroPillar, HeroPillarConfig } from './HeroPillar';
import { HeroCalculator, HeroCalculatorConfig } from './HeroCalculator';
import { AudienceHub, AudienceHubConfig } from './AudienceHub';
import { PolesTriptyque, PolesTriptyqueConfig } from './PolesTriptyque';
import { BentoServices, BentoServicesConfig } from './BentoServices';
import { MarqueeLogos, MarqueeLogosConfig } from './MarqueeLogos';
import { KPIStats, KPIStatsConfig } from './KPIStats';
import { KPICounter, KPICounterConfig } from './KPICounter';
import { LogoCloud, LogoCloudConfig } from './LogoCloud';
import { Testimonials, TestimonialsConfig } from './Testimonials';
import { CaseStudyHighlight, CaseStudyHighlightConfig } from './CaseStudyHighlight';
import { PressReviews, PressReviewsConfig } from './PressReviews';
import { CTA, CTAConfig } from './CTA';
import { CTAFinal, CTAFinalConfig } from './CTAFinal';
import { LeadForm, LeadFormConfig } from './LeadForm';
import { CalculatorEmbed, CalculatorEmbedConfig } from './CalculatorEmbed';
import { Steps, StepsConfig } from './Steps';
import { StepsTimeline, StepsTimelineConfig } from './StepsTimeline';
import { FeatureGrid, FeatureGridConfig } from './FeatureGrid';
import { FAQ, FAQConfig } from './FAQ';
import { FaqSplit, FaqSplitConfig } from './FaqSplit';
import { RichText, RichTextConfig } from './RichText';
import { ComparisonTable, ComparisonTableConfig } from './ComparisonTable';
import { SectorGrid, SectorGridConfig } from './SectorGrid';
import { RelatedArticles, RelatedArticlesConfig } from './RelatedArticles';
import { RelatedCases, RelatedCasesConfig } from './RelatedCases';
import { Quote, QuoteConfig } from './Quote';
import { Stat, StatConfig } from './Stat';
import { Divider, DividerConfig } from './Divider';
import { NewsletterBlock, NewsletterBlockConfig } from './NewsletterBlock';

export const puckConfig: Config = {
  components: {
    HeroPrimary: HeroPrimaryConfig,
    HeroPremium: HeroPremiumConfig,
    HeroMinimal: HeroMinimalConfig,
    HeroDiagnostic: HeroDiagnosticConfig,
    HeroPillar: HeroPillarConfig,
    HeroCalculator: HeroCalculatorConfig,
    AudienceHub: AudienceHubConfig,
    PolesTriptyque: PolesTriptyqueConfig,
    BentoServices: BentoServicesConfig,
    MarqueeLogos: MarqueeLogosConfig,
    KPIStats: KPIStatsConfig,
    KPICounter: KPICounterConfig,
    LogoCloud: LogoCloudConfig,
    Testimonials: TestimonialsConfig,
    CaseStudyHighlight: CaseStudyHighlightConfig,
    PressReviews: PressReviewsConfig,
    CTA: CTAConfig,
    CTAFinal: CTAFinalConfig,
    LeadForm: LeadFormConfig,
    CalculatorEmbed: CalculatorEmbedConfig,
    Steps: StepsConfig,
    StepsTimeline: StepsTimelineConfig,
    FeatureGrid: FeatureGridConfig,
    FAQ: FAQConfig,
    FaqSplit: FaqSplitConfig,
    RichText: RichTextConfig,
    ComparisonTable: ComparisonTableConfig,
    SectorGrid: SectorGridConfig,
    RelatedArticles: RelatedArticlesConfig,
    RelatedCases: RelatedCasesConfig,
    Quote: QuoteConfig,
    Stat: StatConfig,
    Divider: DividerConfig,
    NewsletterBlock: NewsletterBlockConfig,
  },
};

export const BLOCK_RENDERERS = {
  HeroPrimary,
  HeroPremium,
  HeroMinimal,
  HeroDiagnostic,
  HeroPillar,
  HeroCalculator,
  AudienceHub,
  PolesTriptyque,
  BentoServices,
  MarqueeLogos,
  KPIStats,
  KPICounter,
  LogoCloud,
  Testimonials,
  CaseStudyHighlight,
  PressReviews,
  CTA,
  CTAFinal,
  LeadForm,
  CalculatorEmbed,
  Steps,
  StepsTimeline,
  FeatureGrid,
  FAQ,
  FaqSplit,
  RichText,
  ComparisonTable,
  SectorGrid,
  RelatedArticles,
  RelatedCases,
  Quote,
  Stat,
  Divider,
  NewsletterBlock,
} as const;

export type BlockType = keyof typeof BLOCK_RENDERERS;
